import { render, staticRenderFns } from "./DonationBadges.vue?vue&type=template&id=1085f7af"
import script from "./DonationBadges.vue?vue&type=script&setup=true&lang=js"
export * from "./DonationBadges.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports